import React from "react";
import { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./texteditor.css";
const ReactQuill = React.lazy(() => import("react-quill"));

const defaultToolbarOptions = [
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],

  ["clean"], // remove formatting button
];

export interface TextEditorProps extends Omit<ReactQuillProps, "theme"> {
  toolbarOptions?: unknown;
}

export function TextEditor({
  toolbarOptions = defaultToolbarOptions,
  ...props
}: TextEditorProps) {
  return (
    <ReactQuill
      {...props}
      theme="snow"
      modules={{
        toolbar: toolbarOptions,
      }}
      className="text_editor"
    />
  );
}
